import { Question } from './question';
import { FinapiTransaction } from './finapi-transaction';

export enum Rol {
  adminBB = 'ADMINBB',
  admin = 'ADMIN',
  consultant = 'BERATER',
  client = 'KUNDE',
  superConsultant = 'BERATERBB',
  consultantBB = 'BERATERBB',
}

export enum Status {
  active = 'active',
  inactive = 'inactive',
  finish = 'finish',
}

export interface BankAcount {
  bank: string;
  iban: string;
  accountId: string;
  accountHolder: string;
  accountNumber: string;
  accountName: string;
  accountType: string;
}

export class NatPerson {
  _id: string;
  BBKundennummer: number;
  Mandatref: number;
  Mandatkennung: string;
  Firmenname: string;
  Rechtsform: string;
  CrefoID: string;
  SteuerID: string;
  ErsterBelegeingang: Date;
  Risikokennzeichen: string;
  Abtretung: string;
  UeberleitungsID: string;
  BranchenInfo: {
    Fachgebiet: string;
    Art: string;
    ZusatzService: string | undefined;
  };
  Person: {
    Personenart: string;
    Kundenart: string;
    Anrede: string;
    Titel: string;
    Vorname: string;
    Nachname: string;
    Briefanrede: string;
    Geburtsname: string;
    Geburtsdatum: string;
    Geburtsort: string;
    Geburtsland: string;
    RechtsformAuspraegung: string;
    Position: string;
    VollmachtKontoeroeffnung: boolean;
    Vertretungsberechtigt: boolean;
    Wirtschaftlichberechtigt: boolean;
    FiktivWirtschaftlichberechtigt: boolean;
  };
  Legitimationsdaten: {
    Ausweisart: string;
    Ausweisnummer: string;
    AusstellerLand: string;
    AusstellerBehoerde: string;
    AusgestelltAm: string;
    GueltigBis: string;
    GeprueftAm: string;
    GeprueftVonID: string;
    AusfOrganisation: string;
  };
  Dokumente: {
    Ausweiskopie: string;
    EinverstaendnisErklaerungDatenaustausch: string;
  };
  Adresse: {
    PLZ: string;
    Ort: string;
    Strasse: string;
    Land: string;
  };
  Firmenanschrift: {
    PLZ: string;
    Ort: string;
    Strasse: string;
    Land: string;
  };
  Kontakt: {
    Telefon: string;
    Email: string;
  };
}

export class Dokument {
  fileId: string;
  Base64: string;
  FileName: string;
  TS: string;
}

export class JurPerson {
  JurDaten: {
    BBKundennummer: number;
    Personenart: string;
    Kundenart: string;
    Anrede: string;
    Briefanrede: string;
    NamePraegekarte: string;
    NamePraegekarte2: string;
    Firmenname: string;
    Kurzname: string;
    RechtsformAuspraegung: string;
    GbrArt: string;
  };
  Registerdaten: {
    Registerart: string;
    Registergericht: string;
    Registernummer: string;
    EintragDatum: string;
    RegAuszugDatum: string;
    RegGeprueftVon: string;
    RegGeprueftAm: string;
  };
  Adresse: {
    PLZ: string;
    Ort: string;
    Strasse: string;
    Land: string;
  };
  Kontaktdaten: {
    Kontakt: {
      Telefon: string;
      Email: string;
    };
  };
  Dokumente: {
    Handelsregisterauszug: [Dokument];
    Transparenzregister: [Dokument];
    Gesellschafterliste: [Dokument];
    Gesellschaftsvertrag: [Dokument];
    AusweiskopieVertretungsberechtigten: [Dokument];
    Gewerberegister: [Dokument];
    Gesellschafterregister: [Dokument];
    AusweiskopieWB: [Dokument];
    Nachweis_bei_WB: [Dokument];
  };
}
export class User {
  _id: string;
  name: string;
  lastname: string;
  customInfo: string;
  email: string;
  iban: string;
  tagesGeldkontoIban: string;
  kundenNummer: string;
  giroCardOrdered: boolean;
  status: Status;
  finapiProcessToken: string;
  finapiAccessToken: string;
  finapiStatus: string;
  one: {
    institutionId: string;
    orderId: string;
    businessCaseId: string;
    userId: string;
  };
  finapi: {
    counter: number;
    selectedAccountList: BankAcount[];
    creditCheckPdf: {};
    creditCheck: {
      status: string;
      decisionCredit: string;
      decisionAccount: string;
      decision: string;
      derivedCreditLimitAmount: number;
      derivedCreditCardLimitAmount: number;
      creditBureauDataSchufa: {};
      creditBureauDataCrefo: {};
    };
    transactions: FinapiTransaction[];
    identityCheck: [{}];
    payload: { errorCode: string; errorMessage: string };
  };
  lastUpdateDate: Date;
  createAt: Date;
  firstTimeStatusActive: Date;
  firstTimeSubStatusInProcess: Date;
  dateStatusFinish: Date;
  questions: Array<Question>;
  kontokorrentkredit: boolean;
  kontoWechselService: boolean;
  abtretungsvertrag: boolean;
  rol: string;
  isJurPerson: boolean;
  natPersonen: Array<NatPerson>;
  JurPerson: JurPerson;
  lang: string;
  emails: {
    date: Date;
    function: string;
  }[];
  documents: [
    {
      fileId: string;
      documentname: string;
      formularnummer: string;
      ablagenummer: number;
      documentdata: any;
      isIban: boolean;
    },
  ];
  blockedUser: boolean;

  constructor(obj?: any) {
    this.questions = new Array();
    this.rol = Rol.client;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        this[key] = obj[key];
      }
    }
  }
}
